
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    minFontSize: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      fit_font_size: undefined
    }
  },
  computed: {
    fit_style() {
      if (!this.fit_font_size) {
        return
      }
      return  {fontSize: `${this.fit_font_size}px`}
    }
  },
  watch: {
    text() {
      this.$nextTick(() => this.$debounce(this.fitText))
    },
    '$responsive.mobile'() {
      this.$nextTick(() => this.$debounce(this.fitText))
    }
  },
  mounted() {
    this.$nextTick(() => this.$debounce(this.fitText))
  },
  methods: {
    async fitText() {
      this.fit_font_size = undefined
      await this.$nextTick()

      if (this.$el.scrollWidth <= this.$el.clientWidth) return

      const base_size = parseFloat(getComputedStyle(this.$el).fontSize)
      this.fit_font_size = Math.max(
        this.minFontSize,
        Math.min(
          base_size,
          Math.floor(base_size * this.$el.clientWidth / this.$el.scrollWidth * 0.9)
        )
      )
      await this.$nextTick()
    },
  }
}
